<div class="areas-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_AREAS.DESCRIPTION' | translate }}
    </p>
    <tf-settings-areas-list />
  </div>
</div>
